import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { localStorage } from 'dibs-browser-storage';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';

// constants
import { LOCAL_STORAGE_KEY } from '../../constants/measurementUnits';

export class SbSharedMeasurementUnitProviderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMounted: false,
        };
    }

    componentDidMount() {
        this.setState({ isMounted: true });
    }

    render() {
        const { isMounted } = this.state;
        const { defaultMeasurementUnit, user, children, searchBrowse } = this.props;
        const userValue = get(user, 'profile.measurementUnit');
        const storageValue = localStorage.getItem(LOCAL_STORAGE_KEY);

        /**
         * If localstorage value is set to something different than the user value
         * dimensions will flash, this check will set the localstorage value to the user value
         * to prevent the dimension flashing on next refresh
         */
        if (user && userValue !== storageValue) {
            localStorage.setItem(LOCAL_STORAGE_KEY, userValue);
        }

        /**
         * Set the measurement unit with the following order of importance:
         *  1. if it is an applied filter
         *  2. to the users preference
         *  3. to what is stored in localStorage
         *  4. location default
         */

        const appliedFilterValue = get(
            getFilterValues(searchBrowse.appliedFilters, 'measurement-unit'),
            '0.urlLabel',
            ''
        ).toUpperCase();
        const userProfileValue = get(user, 'profile.measurementUnit');
        // only attempt to use localstorage value after component mounts to prevent html mismatch between server and client
        const localStorageValue = isMounted && localStorage.getItem(LOCAL_STORAGE_KEY);
        const defaultLocaleValue = defaultMeasurementUnit;
        const measurementUnit =
            appliedFilterValue || userProfileValue || localStorageValue || defaultLocaleValue;

        return <React.Fragment>{children({ measurementUnit })}</React.Fragment>;
    }
}

SbSharedMeasurementUnitProviderComponent.propTypes = {
    user: PropTypes.object,
    children: PropTypes.func.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    defaultMeasurementUnit: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
    const { measurementUnit } = state;

    return {
        defaultMeasurementUnit: measurementUnit,
    };
};

export const SbSharedMeasurementUnitProvider = createFragmentContainer(
    connect(mapStateToProps)(SbSharedMeasurementUnitProviderComponent),
    {
        user: graphql`
            fragment SbSharedMeasurementUnitProvider_user on User {
                profile {
                    measurementUnit
                }
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedMeasurementUnitProvider_searchBrowse on SearchBrowseQueryConnection {
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
